/**
 * Mock Data: User Gender Statistic
 * Mock data for user gender distribution
 *
 * Corresponds to Postman endpoint: GET /product/api/v1/dashboard/demographics/gender
 */

import type { GenderDemographicsData } from '../data/remote/response';

// Re-export types from response module for backward compatibility
export type { GenderDemographicsData, GenderDemographicsApiResponse } from '../data/remote/response';

// Legacy alias for backward compatibility
export type UserGenderData = GenderDemographicsData;

export const mockUserGenderData: GenderDemographicsData = {
  male: 400000,
  female: 600000,
  total: 1000000,
};
